import { complexCommercialFields } from "src/utils/complexCommercialInfo"
import "firebase/compat/firestore"
import "firebase/compat/auth"
import "firebase/compat/storage"
import { firestore as db } from "src/Firebase"
import { chunk } from "lodash"

export const newConjunto = conjunto =>
  db.collection("conjuntos").add({
    ...complexCommercialFields(conjunto),
    Nombre: conjunto.Nombre,
    Ruc: conjunto.Ruc,
    Imagen: conjunto.Imagen,
    NumResidentes: conjunto.NumResidentes,
    NumParqueaderos: conjunto.NumParqueaderos,
    NumeroComprobante: conjunto.NumComprobante,
    Direccion: conjunto.Direccion,
    Ciudad: conjunto.Ciudad,
    Provincia: conjunto.Provincia,
    Pais: conjunto.Pais,
    LimiteConfianza: conjunto.LimiteConfianza,
    LimiteSesiones: conjunto.LimiteSesiones,
    UltimoMesAlicuota: conjunto.UltimoMesAlicuota,
    Empresa: conjunto.Empresa,
    NombreContacto: conjunto.NombreContacto,
    TelefonoContacto: conjunto.TelefonoContacto,
    CorreoContacto: conjunto.CorreoContacto,
    FechaCreacion: new Date(),
    Parkey: conjunto.Parkey || false,
  })
export const updateConjunto = (conjunto, documentoId) =>
  db
    .collection("conjuntos")
    .doc(documentoId)
    .update({
      ...complexCommercialFields(conjunto),
      Nombre: conjunto.Nombre,
      Ruc: conjunto.Ruc,
      Imagen: conjunto.Imagen,
      NumResidentes: conjunto.NumResidentes,
      NumParqueaderos: conjunto.NumParqueaderos,
      NumeroComprobante: conjunto.NumComprobante,
      Direccion: conjunto.Direccion,
      Ciudad: conjunto.Ciudad,
      Provincia: conjunto.Provincia,
      Pais: conjunto.Pais,
      NombreContacto: conjunto.NombreContacto,
      TelefonoContacto: conjunto.TelefonoContacto,
      CorreoContacto: conjunto.CorreoContacto,
      LimiteConfianza: conjunto.LimiteConfianza,
      LimiteSesiones: conjunto.LimiteSesiones,
      UltimoMesAlicuota: conjunto.UltimoMesAlicuota,
      Empresa: conjunto.Empresa || "",
      Parkey: conjunto.Parkey || false,
    })

export const deleteConjuntoById = userName =>
  db.collection("conjuntos").doc(userName).delete()

export const getAllProvincias = () => db.collection("provincias").get()

export const getAllEmpresas = async () => {
  const snap = await db.collection("empresas").get()
  return snap.docs.map(doc => ({ ...doc.data(), id: doc.id }))
}

export const getCiudadesByProvincias = Ciudad =>
  db.collection("provincias").doc(Ciudad).collection("canton").get()

export const createRubros = conjuntoID => {
  const rubrosI = [
    {
      Tipo: "Ingreso",
      Nombre: "Ingresos ordinarios",
      SubRubros: [
        "Alícuota mensual",
        "Cuota por seguro",
        "Consumo de agua",
        "Consumo de gas",
        "Consumo de energia",
        "Saldo a favor",
      ],
    },
    {
      Tipo: "Ingreso",
      Nombre: "Saldos iniciales",
      SubRubros: ["Saldo Inicial"],
    },
    {
      Tipo: "Ingreso",
      Nombre: "Ingresos extraordinarios",
      SubRubros: [
        "Reserva áreas comunales",
        "Multas",
        "Cuota extraordinaria",
        "Intereses",
        "Notas de crédito bancarias",
        "Descuento",
      ],
    },
    {
      Tipo: "Egreso",
      Nombre: "Servicios básicos",
      SubRubros: [
        "Agua potable",
        "Energía eléctrica",
        "Consumo teléfono",
        "Servicio de internet",
        "Consumo de gas",
        "Aseguradora",
      ],
    },
    {
      Tipo: "Egreso",
      Nombre: "Salarios y beneficios de ley",
      SubRubros: [
        "Sueldos personal",
        "Décimo tercer sueldo",
        "Décimo cuarto sueldo",
        "Aporte IESS",
        "Fondos de reserva",
        "Indemnización",
        "Horas extras",
      ],
    },
    {
      Tipo: "Egreso",
      Nombre: "Mantenimientos y reparaciones",
      SubRubros: [
        "Mantenimiento de bombas y equipo hidroneumático",
        "Mantenimiento e instalaciones eléctricas",
        "Mantenimiento extintores",
        "Mantenimiento de caldero",
        "Mantenimiento equipos de agua caliente",
        "Mantenimiento e instalaciones de Gas",
        "Mantenimiento de equipos de computo",
        "Mantenimiento de ascensor",
        "Mantenimiento de generador",
        "Mantenimiento y construccion de jardines",
        "Mantenimiento de cámaras de seguridad",
        "Mantenimiento de puertas de acceso vehícular",
        "Mantenimiento puerta principal",
        "Mantenimiento cisternas",
      ],
    },
    {
      Tipo: "Egreso",
      Nombre: "Gastos administrativos",
      SubRubros: [
        "Sistema de administración",
        "Movilización varias gestiones",
        "Administración",
        "Gastos varios",
      ],
    },
    {
      Tipo: "Egreso",
      Nombre: "Seguridad",
      SubRubros: ["Servicios de guardianía"],
    },
    {
      Tipo: "Egreso",
      Nombre: "Prestacion de servicios",
      SubRubros: [
        "Servicios contables",
        "Servicios legales",
        "Servicios de limpieza",
        "Póliza contra incendios",
      ],
    },
    {
      Tipo: "Egreso",
      Nombre: "Servicios bancarios",
      SubRubros: ["Comisiones bancarias", "Débito cheques devueltos"],
    },
    {
      Tipo: "Egreso",
      Nombre: "Caja chica",
      SubRubros: [
        "Cafetería",
        "Suministros de caja oficina",
        "Suministros de limpieza",
        "Devolución garantía salón comunal",
      ],
    },
  ]
  const batch = db.batch()
  const conjuntoRef = db.collection("conjuntos").doc(conjuntoID)
  batch.set(conjuntoRef.collection("conjuntoConfig").doc("Subconjuntos"), {
    listaSubconjuntos: [],
    tiposUnidades: [],
  })
  rubrosI.forEach(rubro => {
    const rubroRef = conjuntoRef.collection("rubros").doc(rubro.Nombre)
    batch.set(rubroRef, {
      Nombre: rubro.Nombre,
      Tipo: rubro.Tipo,
      SubRubros: rubro.SubRubros,
    })
  })
  return batch.commit()
}

export const TipoVisita = (conjuntoId, ListaVisitas) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("TiposVisita")
    .set({ ListaVisitas })

export const FormadeCobroPago = (conjuntoId, FormaCobroPago) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Modulos")
    .set(FormaCobroPago)

export const Modulos = conjuntoId =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Modulos")
    .get()

export const updateConjuntoModulos = (data, documentoId) =>
  db
    .collection("conjuntos")
    .doc(documentoId)
    .collection("conjuntoConfig")
    .doc("Modulos")
    .update(data)

export const checkMora = async conjuntoId => {
  const rubroRef = db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("rubros")
    .doc("Ingresos ordinarios")

  const rubroSnap = await rubroRef.get()
  if (!rubroSnap.exists) return
  const rubroData = rubroSnap.data()
  const subRubros = rubroData.SubRubros || []
  const existeInteresesMora = subRubros.some(
    subRubro => subRubro === "Intereses por mora"
  )

  if (!existeInteresesMora) {
    await rubroRef.update({
      SubRubros: [...subRubros, "Intereses por mora"],
    })
  }
}

export const updateEnableConjunto = async (documentoId, value) => {
  try {
    // update complex state
    await db.collection("conjuntos").doc(documentoId).update({
      isActive: value.isActive,
      States: value.States,
    })
    // update all users
    const usersDocs = await db
      .collection("usuarios")
      .where("ConjuntoUidResidencia", "==", documentoId)
      .get()
    // execute batch
    const chunks = chunk(usersDocs.docs, 500)
    const promises = chunks.map(chunkData => {
      const batch = db.batch()
      chunkData.forEach(doc => {
        const userRef = db.collection("usuarios").doc(doc.id)
        batch.update(userRef, { isActive: value.isActive })
      })
      return batch.commit()
    })
    await Promise.all(promises)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error updating document: ", error)
  }
}

export const createParkey = (idConjunto, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .set(data)

export const getParkey = (observer, idConjunto) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .onSnapshot(observer)

export const updateParkey = (idConjunto, data) =>
  db
    .collection("conjuntos")
    .doc(idConjunto)
    .collection("conjuntoConfig")
    .doc("Parkey")
    .update(data)

// Impresion por Rasp
export const saveConfigRasp = (conjuntoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Rasp")
    .set(data, { merge: true })

export const getConfigRasp = conjuntoId =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("Rasp")
    .get()

// Guardar QR Local
export const saveConfigQrLocal = (conjuntoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("QrLocal")
    .set(data, { merge: true })

export const getConfigQrLocal = conjuntoId =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("QrLocal")
    .get()

// Guardar Tags Local
export const saveConfigTagsLocal = (conjuntoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("TagsLocal")
    .set(data, { merge: true })

export const getConfigTagsLocal = conjuntoId =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("TagsLocal")
    .get()

// Guardar QR Local para Pisos
export const saveConfigQrPisosLocal = (conjuntoId, data) =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("QrLocalPisos")
    .set(data, { merge: true })

export const getConfigQrPisosLocal = conjuntoId =>
  db
    .collection("conjuntos")
    .doc(conjuntoId)
    .collection("conjuntoConfig")
    .doc("QrLocalPisos")
    .get()

// Dispositivos biometricos (subcoleccion rostros)
const rostrosCollection = conjuntoId =>
  db.collection("conjuntos").doc(conjuntoId).collection("rostros")

export const subscribeRostros = (conjuntoId, observer) =>
  rostrosCollection(conjuntoId).onSnapshot(observer)

export const createRostro = (conjuntoId, data) =>
  rostrosCollection(conjuntoId).add(data)

export const updateRostro = (conjuntoId, rostroId, data) =>
  rostrosCollection(conjuntoId).doc(rostroId).update(data)

export const deleteRostro = (conjuntoId, rostroId) =>
  rostrosCollection(conjuntoId).doc(rostroId).delete()

export const hasRostroImagenes = async (conjuntoId, rostroId) => {
  const snap = await rostrosCollection(conjuntoId)
    .doc(rostroId)
    .collection("imagenes")
    .limit(1)
    .get()
  return !snap.empty
}

// endconjuntos
